/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ReorderLeaveGroupOrderMutationVariables = Exact<{ [key: string]: never }>;

export type ReorderLeaveGroupOrderMutation = {
  readonly leaveMultipartyOrder:
    | { readonly __typename: 'LeaveOrderSuccess'; readonly success: boolean }
    | { readonly __typename: 'MultipartyOrderNotFound'; readonly errorMessage: string }
    | { readonly __typename: 'OrderLocked'; readonly errorMessage: string }
    | { readonly __typename: 'ValidationError'; readonly message: string };
};

export const ReorderLeaveGroupOrderDocument = gql`
  mutation ReorderLeaveGroupOrder {
    leaveMultipartyOrder {
      __typename
      ... on LeaveOrderSuccess {
        success
      }
      ... on MultipartyOrderNotFound {
        errorMessage
      }
      ... on OrderLocked {
        errorMessage
      }
      ... on ValidationError {
        message
      }
    }
  }
`;

export function useReorderLeaveGroupOrderMutation() {
  return Urql.useMutation<ReorderLeaveGroupOrderMutation, ReorderLeaveGroupOrderMutationVariables>(
    ReorderLeaveGroupOrderDocument,
  );
}
